import axios from 'axios';

import type {
  LiveClassFeedback,
  LiveClassFeedbackResponse,
} from '../interfaces';
import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class FeedbacksDao {
  static async submitFeedback(
    env: Environment,
    liveClassFeedback: LiveClassFeedback
  ) {
    const url = hostsConfig[env].courseServiceHost;
    const { data } = await axios.post<LiveClassFeedbackResponse>(
      `${url}/v1/liveclassfeedbacks`,
      liveClassFeedback
    );

    return data;
  }
}
